export const CSR_redirectModal = {
    "show_redirect_modal" : false,
    "csr_payer_name" : "",
    "csr_payer_logo" : "",
    "csr_customer_id" : ""
}